import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { protectSheetWithRandomPassword } from "../ExcelUtils";

export const exportBookEntryDetails = async (apiResponse, loginPlaceId) => {
    const data = apiResponse?.data;
    if (!data) return;

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Book Entry");

    // =========================
    // 🎨 COLORS
    // =========================
    const BLUE_DARK = "1F4E79";
    const BLUE_LIGHT = "D9E1F2";
    const WHITE = "FFFFFF";

    // =========================
    // 🏷 TITLE
    // =========================
    const titleRow = sheet.addRow(["BOOK ENTRY DETAILS"]);
    sheet.mergeCells("A1:F1");

    titleRow.font = { bold: true, size: 16, color: { argb: WHITE } };
    titleRow.alignment = { horizontal: "center", vertical: "middle" };
    titleRow.height = 25;
    titleRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: BLUE_DARK }
    };

    // =========================
    // 📄 HEADER INFO
    // =========================
    const infoRows = [
        ["Transaction Number", data.transactionNumber],
        ["Transaction Type", data.transactionType],
        ["Value Date", formatDate(data.valueDate)],
        ["Account", data.account],
        ["Branch", data.branchName],
        ["User", data.user],
        ["Memo", data.memo],
        ["Authorized By", data.authBy || "-"]
    ];

    infoRows.forEach(row => {
        const r = sheet.addRow(row);
        sheet.mergeCells(`B${r.number}:F${r.number}`);

        r.getCell(1).font = { bold: true };
        r.getCell(1).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: BLUE_LIGHT }
        };

        r.eachCell(cell => {
            cell.border = {
                top: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" }
            };
        });
    });

    sheet.addRow([]);

    // =========================
    // 📊 TABLE HEADER
    // =========================
    const headerRow = sheet.addRow([
        "Ledger Code",
        "Ledger Account",
        "Debit",
        "Credit",
        "Note",
        "Account"
    ]);

    headerRow.eachCell(cell => {
        cell.font = { bold: true, color: { argb: WHITE } };
        cell.alignment = { horizontal: "center" };
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: BLUE_DARK }
        };
        cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
        };
    });

    // =========================
    // 📄 DATA ROWS
    // =========================
    data.bookEntryLedgerAccountDtoList.forEach((item, index) => {
        const row = sheet.addRow([
            item.ledgerCode,
            item.ledgerAccount,
            item.debit || 0,
            item.credit || 0,
            item.note,
            item.account
        ]);

        row.eachCell(cell => {
            cell.border = {
                top: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" }
            };

            cell.alignment = { vertical: "middle" };

            // 💡 Zebra striping
            if (index % 2 === 0) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "F2F6FC" }
                };
            }
        });
    });

    // =========================
    // 📏 COLUMN WIDTHS
    // =========================
    sheet.columns = [
        { width: 15 },
        { width: 30 },
        { width: 12 },
        { width: 12 },
        { width: 15 },
        { width: 20 }
    ];

    if (loginPlaceId === "1") {
        const password = protectSheetWithRandomPassword(sheet, 12);
        console.log(`Sheet protected with password: ${password}`);
    }

    // =========================
    // 📥 EXPORT
    // =========================
    try {
        const buffer = await workbook.xlsx.writeBuffer();

        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(blob, `BookEntry_${data.transactionNumber}.xlsx`);
    } catch (error) {
        console.error("Excel Export Failed:", error);
    }
};

// =========================
// 📅 DATE FORMATTER
// =========================
const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0];
};